<div class="ui basic segment">
    <app-employee-header [employee]="employee"></app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content">
            <!--No surveys-->
            <app-table [table]="table">
                <app-empty-state label="surveys.noSurveysFound" src="/assets/illustrations/clipboard-question-mark.png">
                </app-empty-state>
            </app-table>
        </div>
    </div>
</div>
